import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Container,
    Paper,
    Typography,
    Box,
    Button,
    Grid,
    Divider,
    Alert
} from '@mui/material';
import { Reservation } from '../../types';

const Confirmation: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { reservation, paymentIntent } = location.state || {};

    if (!reservation || !paymentIntent) {
        return (
            <Container maxWidth="md" sx={{ mt: 4 }}>
                <Alert severity="error">
                    Impossible de trouver les détails de la réservation. Veuillez contacter le support.
                </Alert>
            </Container>
        );
    }

    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Confirmation de réservation
                </Typography>

                <Alert severity="success" sx={{ mb: 3 }}>
                    Votre réservation a été confirmée avec succès !
                </Alert>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            Détails de la réservation
                        </Typography>
                        <Box sx={{ mb: 2 }}>
                            <Typography><strong>Activité :</strong> {reservation.product.name}</Typography>
                            <Typography><strong>Date :</strong> {formatDate(reservation.date)}</Typography>
                            <Typography><strong>Heure :</strong> {reservation.time}</Typography>
                            <Typography><strong>Nombre de participants :</strong> {reservation.participants}</Typography>
                            <Typography><strong>Niveau :</strong> {reservation.level}</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            Informations client
                        </Typography>
                        <Box sx={{ mb: 2 }}>
                            <Typography><strong>Nom :</strong> {reservation.customer.name}</Typography>
                            <Typography><strong>Email :</strong> {reservation.customer.email}</Typography>
                            <Typography><strong>Téléphone :</strong> {reservation.customer.phone}</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            Détails du paiement
                        </Typography>
                        <Box sx={{ mb: 2 }}>
                            <Typography><strong>Montant :</strong> {reservation.payment.amount} €</Typography>
                            <Typography><strong>Statut :</strong> {reservation.payment.status}</Typography>
                            <Typography><strong>ID de transaction :</strong> {paymentIntent}</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate('/')}
                            >
                                Retour à l'accueil
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => window.print()}
                            >
                                Imprimer la confirmation
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default Confirmation;